import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import { Card, Col, Row } from 'react-bootstrap';



const APIAssistantTester: React.FC = () => {

    const { t } = useTranslation();

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('API assistant Tester'),
            active: true
        }
    ];

    const formatText = (text: string) => {
        return text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
    };


    const [jsonInput, setJsonInput] = useState<string>('');
    const [currentInput, setCurrentInput] = useState<string>('');
    const [messages, setMessages] = useState<{ role: string; content: string }[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const handleSend = async () => {
        //if (!currentInput.trim()) return;

        setLoading(true);

        try {
            const response = await fetch('https://wjcaknpjxzdipzkuxxgsdr3bey0kyymm.lambda-url.eu-west-1.on.aws/v1/prompt', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    user_prompt: currentInput,
                    agent_name: "mentor",
                    transcription: jsonInput,
                    past_messages: [] // Optional: in the future you can add chat history here
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to send prompt');
            }

            const data = await response.json();

            console.log(data);
            // Assuming your API returns the agent reply under something like data.reply
            const agentReply = data.reply.content || "No reply";

            // Update messages history
            if (currentInput == "") {
                setMessages(prev => [
                    ...prev,
                    { role: "agent", content: agentReply }
                ]);
            } else {
                setMessages(prev => [
                    ...prev,
                    { role: "user", content: currentInput },
                    { role: "agent", content: agentReply }
                ]);
            }

            // Clear current input
            setCurrentInput("");

        } catch (error) {
            console.error(error);
            alert("There was an error sending the prompt.");
        } finally {
            setLoading(false);
        }
    };

    const handleClean = () => {
        // Clear current input
        setCurrentInput("");
        setJsonInput("");
        setLoading(false);
        setMessages([]);
    };

    return (
        <div className="container mt-5">
            <PageBreadcrumb items={breadcrumbItems} />
            <p>Meeting transcription</p>
            {/* Top Area: JSON Input */}
            <div className="mb-4">
                <textarea
                    className="form-control"
                    rows={8}
                    placeholder="Paste your transcription text here..."
                    value={jsonInput}
                    onChange={(e) => setJsonInput(e.target.value)}
                />
            </div>

            {/* Middle Area: Chat Display */}
            <div className="mb-4 border rounded p-3" style={{ height: "300px", overflowY: "auto", background: "#f8f9fa" }}>
                {messages.map((msg, index) => (
                    <div key={index} className={`mb-2 ${msg.role === "user" ? "text-end" : "text-start"}`}>
                        <span className={msg.role === 'user' ? 'badge bg-primary mb-2' : 'badge bg-secondary mb-2'} >{msg.role}</span>
                        <div className={msg.role === 'user' ? '' : 'bg-200'}>{formatText(msg.content)}</div>
                    </div>
                ))}
            </div>

            {/* Bottom Area: Input Field */}
            <div className="d-flex">
                <input
                    type="text"
                    className="form-control me-2"
                    placeholder="Type your question..."
                    value={currentInput}
                    onChange={(e) => setCurrentInput(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSend()}
                    disabled={loading}
                />
                <button className="btn btn-primary me-2" onClick={handleSend} disabled={loading}>
                    {loading ? "Sending..." : "Send"}
                </button>

                <button className="btn btn-danger" onClick={handleClean} >Clean </button>

            </div>
        </div>
    );
}

export default APIAssistantTester;
